import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { SCHOOL } from '../../Paths';
import { Main } from '../common/blocks/Main';
import { ReactComponent as ProfileIcon } from '../../images/profile.svg';
import { push } from 'connected-react-router';
import {
	actionCreators as studentActions,
	getStudentTicketText,
	isLoadingStudentTickets,
	getStudentBearers,
	getReferredAccount,
	referredAccountsLoaded,
	isLoadingReferredAccounts,
	getAllTicketVendorIds,
	getStudentsByPage,
	isSearchingStudents,
} from '../../reducer/students';
import { actionCreators as groupActions } from '../../reducer/groups';
import {
	actionCreators as orderActions,
	getTicketOrders,
	hasProcessingTicketOrders,
} from '../../reducer/school/orders';
import {
	getStudents,
	getAllGroups,
	isLoadingStudents,
	isLoadingStudentBearers,
} from '../../reducer';
import isEmpty from 'lodash/isEmpty';
import StudentPopup from './StudentPopup';
import { GroupTable } from './GroupPage';
import { displayTravelCardInList } from './GroupDetailsPage';
import { Loading } from '../common/blocks/Loading';
import { TextInput } from '../common/elements/TextInput';
import { ReactComponent as Search } from '../../images/search.svg';
import debounce from 'lodash/debounce';
import { Pagination } from '../common/elements/Pagination';
import withTextContext from '../../utils/withTextContext';
import { Banner } from '../common/blocks/Banner';

class StudentPage extends Component {
	state = {
		showPopup: false,
		popupStudentData: null,
		searchTerm: '',
		searchResults: [],
		isSearch: false,
		//studentBearers: {},
		currentPage: 0,
		pageSize: 30,
		studentCount: 0,
		waitingForReload: false,
		reloadTickets: false,
	};

	ticketOrderTimeOut = 0;

	componentDidMount() {
		this.loadData();

		(async () => {
			await this.props.getTicketOrders();
		})();
		this.maybeReloadTicketOrders();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.searchTerm !== this.state.searchTerm) {
			this.searchStudents();
		}

		if (prevState.currentPage !== this.state.currentPage && !this.state.isSearch) {
			this.loadData(this.state.currentPage);
		}

		if (prevState.reloadTickets !== this.state.reloadTickets && this.state.reloadTickets && !this.state.isSearch) {
			this.loadStudentPageData(this.state.currentPage);
		}

		this.maybeReloadTicketOrders();
	}

	componentWillUnmount() {
		clearInterval(this.ticketOrderTimeOut)
	}

	searchStudents = async () => {
		const { searchTerm } = this.state;

		if (searchTerm !== "") {
			const students = await this.props.searchSchoolStudents(searchTerm);

			if (students != null) {
				this.setState({
					searchResults: students,
					isSearch: true,
					currentPage: 0,
				});

				const studentIds = students.map(s => s.contactId);
				const travellerIds = students.map(s => s.travellerId);
				const showLoading = true;

				this.props.getBearersForStudents(travellerIds, showLoading);
				this.props.getTicketsForStudentIds(travellerIds, showLoading);

				const referredAccounts = await this.props.getReferredAccounts(studentIds, showLoading);
				this.props.getAllReferredAccountTickets(referredAccounts, showLoading);
			}
		} else {
			this.setState({
				searchResults: [],
				isSearch: false,
				currentPage: 0,
			});
		}
	}

	maybeReloadTicketOrders = async () => {
		if (this.props.hasProcessingTicketOrders && !this.state.waitingForReload) {
			this.setState({
				waitingForReload: true,
				reloadTickets: false,
			});

			this.ticketOrderTimeOut = setTimeout(() => {
				(async () => {
					await this.props.getTicketOrders();

					this.setState({
						waitingForReload: false,
						reloadTickets: true,
					});
				})();
			}, '30000');
		}
	}

	loadData = async (currentPage = 0) => {
		const {
			groups,
			studentsByPage,
		} = this.props;
		const { reloadTickets } = this.state;
		const nextPage = currentPage + 1;

		if (studentsByPage[currentPage] == null || reloadTickets) {
			this.loadStudentPageData(currentPage);
		}

		const studentCount = await this.props.fetchStudentCount();

		if (studentCount != null) {
			this.setState({ studentCount });
		}

		if (studentsByPage[nextPage] == null) {
			this.loadStudentPageData(nextPage, false);
		}

		if (isEmpty(groups)) {
			await this.props.getGroups();
		}

		const vendorIds = this.props.getAllTicketVendorIds || [];
		vendorIds.forEach(vendorId => this.props.getSchoolByVendorId(vendorId));
	};

	loadStudentPageData = async (page, showLoading = true) => {
		const students = await this.props.getStudentsByPage(page, showLoading);

		if (students == null || students.length === 0) {
			return;
		}

		const studentIds = students.map(s => s.contactId);
		const travellerIds = students.map(s => s.travellerId);
		this.props.getBearersForStudents(travellerIds, showLoading);
		this.props.getTicketsForStudentIds(travellerIds, showLoading);

		const referredAccounts = await this.props.getReferredAccounts(studentIds, showLoading);
		this.props.getAllReferredAccountTickets(referredAccounts, showLoading);
	}

	showStudentDetails = student => () =>
		this.setState(state => ({
			showPopup: !state.showPopup,
			popupStudentData: student.travellerId,
		}));

	closePopup = () =>
		this.setState(state => ({
			showPopup: !state.showPopup,
			popupStudentData: null,
		}));

	displayGroupInList = groups => {
		const names = (groups || []).map(g => g.groupName);

		if (names.length > 0) {
			return `${names[0]} ${names.length > 1 ? '+' : ''}`;
		}

		return '';
	};

	handleChange = debounce(target => {
		const searchValue = target.value.trim();
		this.setState({ searchTerm: searchValue });
	}, 400);

	handlePageChange = newPage => this.setState({ currentPage: newPage - 1 });

	render() {
		const {
			isLoadingStudents,
			isSearching,
			isLoadingStudentBearers,
			isLoadingStudentTickets,
			selectStudentBearers,
			studentTicketText,
			getReferredAccount,
			isLoadingReferredAccounts,
			texts,
			studentsByPage,
		} = this.props;
		const {
			showPopup,
			popupStudentData,
			currentPage,
			pageSize,
			searchResults,
			isSearch,
			searchTerm,
			studentCount,
		} = this.state;

		let sortedStudents = [];

		const studentsCurrentPage = studentsByPage[currentPage] != null ? Object.values(studentsByPage[currentPage]) : [];
		const studentList = isSearch ? searchResults : studentsCurrentPage;
		const currentStudentCount = isSearch ? searchResults.length : studentCount;

		if (studentList != null && studentList.length > 0) {
			sortedStudents = studentList.sort((a, b) =>
				a.lastName.localeCompare(b.lastName)
			);

			if (isSearch) {
				sortedStudents = sortedStudents.slice(
					pageSize * currentPage,
					pageSize * currentPage + pageSize
				);
			}
		}

		return (
			<>
				<Banner bannerImg={texts.school.images.banners.grouppage}>
					<h2>Elever &amp; Grupper</h2>
					<p>Här hanteras elevinformation, skolkort och grupper</p>
				</Banner>
				<Main>
					<LinkContainer>
						<Link to={SCHOOL.GROUPS} exact activeClassName="active">
							Grupper
						</Link>
						<Link to={SCHOOL.STUDENTS} exact activeClassName="active">
							Elever
						</Link>
					</LinkContainer>

					{isSearching && (
						<Loading text="Söker elever. Detta kan dröja några sekunder..." />
					)}

					{isLoadingStudents && (
						<Loading text="Laddar alla elever. Detta kan dröja några sekunder..." />
					)}
					{(isLoadingStudentBearers ||
						isLoadingStudentTickets ||
						isLoadingReferredAccounts) && (
						<Loading text="Laddar biljetter, resekort och kopplade konton..." />
					)}

					<StudentCountContainer>
						<SearchFieldContainer>
							<SearchIcon aria-hidden="true" focusable="false" />
							<SearchStudent
								type="text"
								value={searchTerm}
								handleChange={this.handleChange}
								placeholder="Namn, telefonnummer, personnummer, kortnummer eller hemkommun"
								helperText="Kortnummersök krävs minst 4 tecken, telefonnummersök kräver fullständigt telefonnummer"
							/>
						</SearchFieldContainer>
						<br />
						<strong>Antal elever: </strong>
						{sortedStudents.length !== studentList.length ? (
							<span>
								{sortedStudents.length} av {currentStudentCount} st
							</span>
						) : (
								<span>{currentStudentCount} st</span>
						)}
					</StudentCountContainer>
					<GroupTable>
						<thead>
							<tr>
								<th />
								<th>Efternamn</th>
								<th>Förnamn</th>
								<th>Personnummer</th>
								<th>Hemkommun</th>
								<th>Biljetter</th>
								<th>Reseapp</th>
								<th>Resekort</th>
								<th>Grupp</th>
							</tr>
						</thead>

						<tbody>
							{sortedStudents.map((student, idx) => {
								let referredAccount = getReferredAccount(student.travellerId);
								return (
									<tr key={idx} onClick={this.showStudentDetails(student)}>
										<td>
											<ProfileIcon aria-hidden="true" focusable="false" />
										</td>
										<td>{student.lastName}</td>
										<td>{student.firstName}</td>
										<td>{student.personalIdentityNumber}</td>
										<td>{student.homeCounty ? student.homeCounty : '-'}</td>
										<td>{studentTicketText(student.travellerId)}</td>
										<td>
											{referredAccount
												? referredAccount.referredAccountPhoneNumber
													? `+${referredAccount.referredAccountPhoneNumber}`
													: 'Ja'
												: 'Nej'}
										</td>
										<td className="nowrap">
											{displayTravelCardInList(
												selectStudentBearers(student.travellerId)
											)}
										</td>
										<td>{this.displayGroupInList(student.groupInformation)}</td>
									</tr>
								);
							})}
						</tbody>
					</GroupTable>
					<Pagination
						itemCount={currentStudentCount}
						itemsPerPage={pageSize}
						onPageChange={this.handlePageChange}
					/>
				</Main>
				{showPopup && (
					<StudentPopup
						closePopup={this.closePopup}
						travellerId={popupStudentData}
					/>
				)}
			</>
		);
	}
}

const SearchFieldContainer = styled.div`
	position: relative;
	display: inline-block;
`;

const SearchIcon = styled(Search)`
	position: absolute;
	top: 0.5em;
	left: 1em;
	stroke: ${props => props.theme.light_grey};
`;

const SearchStudent = styled(TextInput)`
	width: 530px;
	margin-bottom: 1em;
	font-size: 14px;
	font-style: italic;
	padding-left: 3.5em;
`;

const Link = styled(NavLink)`
	color: black;
	text-decoration: none;

	&:hover,
	&:focus,
	&.active {
		color: black;
		text-decoration: none;
		border-bottom: solid 2px;
	}

	& + & {
		margin-left: 2em;
	}
`;

const LinkContainer = styled.div`
	text-align: center;
	padding: 2em;
`;

const StudentCountContainer = styled.div`
	text-align: center;
	padding-bottom: 1em;
`;

export default withTextContext(
	connect(
		store => ({
			students: getStudents(store),
			studentsByPage: getStudentsByPage(store),
			groups: getAllGroups(store),
			isSearching: isSearchingStudents(store),
			isLoadingStudents: isLoadingStudents(store),
			selectStudentBearers: getStudentBearers(store),
			isLoadingStudentBearers: isLoadingStudentBearers(store),
			isLoadingStudentTickets: isLoadingStudentTickets(store),
			studentTicketText: getStudentTicketText(store),
			getReferredAccount: getReferredAccount(store),
			hasReferredAccounts: referredAccountsLoaded(store),
			isLoadingReferredAccounts: isLoadingReferredAccounts(store),
			getAllTicketVendorIds: getAllTicketVendorIds(store),
			hasProcessingTicketOrders: hasProcessingTicketOrders(store),
			orders: getTicketOrders(store),
		}),
		{
			...studentActions,
			...groupActions,
			...orderActions,
			push,
		}
	)(StudentPage)
);
